/* Progressive enhancement: all report results remain readable without JavaScript. */
(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    let selectedStatus = 'all';
    const category = root.querySelector('[data-category-filter]');
    const filters = [...root.querySelectorAll('[data-status-filter]')];
    const markers = [...root.querySelectorAll('.pvr-marker')];
    const update = () => {
      const selectedCategory = category.value;
      let count = 0;
      markers.forEach(marker => {
        const visible = (selectedStatus === 'all' || marker.dataset.status === selectedStatus)
          && (selectedCategory === 'all' || marker.dataset.category === selectedCategory);
        marker.hidden = !visible;
        if (visible) count++;
      });
      root.querySelector('[data-filter-count]').textContent = `${count} evaluări afișate`;
      root.querySelector('.pvr-empty').hidden = count > 0;
      filters.forEach(button => {
        const active = button.dataset.statusFilter === selectedStatus;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    filters.forEach(button => button.addEventListener('click', () => {
      selectedStatus = button.dataset.statusFilter;
      update();
    }));
    category.addEventListener('change', update);
    const links = [...root.querySelectorAll('.pvr-nav a')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          links.forEach(link => {
            const active = link.getAttribute('href') === `#${entry.target.id}`;
            link.classList.toggle('is-active', active);
            if (active) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      }, {rootMargin: '-10% 0px -65% 0px'});
      links.forEach(link => {
        const target = root.querySelector(link.getAttribute('href'));
        if (target) observer.observe(target);
      });
    }
  }
  document.querySelectorAll('.pvr').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.pvr')));
})();
